(function (upp) {
    'use strict';

    function validateTypeOptions(field, value) {
        // Non required are not subject to valid-option selection
        if (!field.required)
            return true
        // Check that selected option is one of the available options
        return field.options.find(function(option) {
            return option.id === value
        });
    }

    upp.directive('customerFieldTypeValidation', [ 'customerFieldType', function(customerFieldType) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                scope.$watch(attrs['ngModel'], function(value) {
                    var field = scope.$eval(attrs['customerFieldTypeValidation']);
                    var type = field.type;
                    var valid = true;
                    if (type === customerFieldType.OPTIONS)
                        valid = valid && validateTypeOptions(field, value);
                    // TODO: Check other types.
                    ngModel.$setValidity('customerFieldValue', valid);
                });
            },
        };
    } ]);
}(upp));


// WEBPACK FOOTER //
// ./src/app/modules/customer-account/directives/customer-field-type-valiation.directive.js